/* eslint-disable prefer-destructuring */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-continue */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line no-use-before-define
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { ConfigProvider, Menu as MenuAnt, MenuProps } from 'antd';
import { useHistory } from 'react-router-dom';
import uniqid from 'uniqid';
import { useSelector } from 'react-redux';
import {
  DownloadOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FundOutlined,
  HistoryOutlined,
  LineChartOutlined,
  ProfileOutlined,
  SettingOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';

import { config } from 'core/config';
import { ApplicationState } from 'store/combineReducers';
import { SvgComponent } from 'shared/components';
import { RolesEnum } from 'core/models';
import { useTranslation } from 'react-i18next';
import { MenuItems } from '../menuItems';
import './style.less';

const {
  profile,
  clinics,
  pmManagement,
  adminManagement,
  techManagement,
  physicianManagement,
  devices,
  sensors,
  patients,
  monitoringProtocols,
  dashboard,
  dashboardEvent,
  dashboardRpmAlert,
  ecgDataChunks,
  reports,
  reportArchive,
  process,
  settings,
  mcpSetting,
  analysisSetting,
  otherSetting,
  groupManagement,
  historyView,
  sites,
  studies,
  studiesManagement,
  researchersManagement,
  userManagement,
  emailTemplate,
  smsTemplate,
  patientTemplate,
  dataAnalytics,
  management,

  rpmRT,
  rpmRTList,
  addRpmPatient,

  orderManagement,

  tenant,
  tenantDevice,
  downloads,
  ssoSetting,
} = config.paths;

const userListId = uniqid();
const pmListId = uniqid();
const sitesId = uniqid();
const studiesId = uniqid();
const studiesManagementId = uniqid();
const researchersId = uniqid();
const adminListId = uniqid();
const techListId = uniqid();
const physicianListId = uniqid();
const profileId = uniqid();
const assessmentsManagementId = uniqid();
const devicesId = uniqid();
const sensorsId = uniqid();
const patientsId = uniqid();
const dashboardId = uniqid();
const dashboardEventId = uniqid();
const dashboardRpmAlertId = uniqid();
const monitoringProtocolsId = uniqid();
const ecgDataChunksId = uniqid();
const reportsId = uniqid();
const reportArchiveId = uniqid();
const processId = uniqid();
const settingsId = uniqid();
const mcpSettingId = uniqid();
const analysisSettingId = uniqid();
const otherSettingId = uniqid();
const patientTemplateId = uniqid();
const groupManagementId = uniqid();
const historyId = uniqid();
const PatientsId = uniqid();
const emailTemplateId = uniqid();
const smsTemplateId = uniqid();
const ssoSettingId = uniqid();
const dataAnalyticsId = uniqid();
const tenantDeviceId = uniqid();
const managementId = uniqid();

const rpmRTId = uniqid();

const orderManagementId = uniqid();

export interface MenuItem {
  id: string;
  title: string;
  path: string;
  subMenu?: MenuItem[];
  icon?: ReactElement<HTMLSpanElement>;
}

export default function Menu(): ReactElement {
  const history = useHistory();
  const user = useSelector((state: ApplicationState) => state.session?.user);
  const { t } = useTranslation();

  const { settingInfo } = useSelector(
    (state: ApplicationState) => state.settingInfo,
  );

  const menuList: MenuItem[] = [
    {
      id: dataAnalyticsId,
      title: t('menu.dataAnalytics'),
      path: dataAnalytics,
      icon: <LineChartOutlined />,
    },
    {
      id: dashboardId,
      title: t('menu.monitoring'),
      path: dashboard,
      icon: <FundOutlined />,
      subMenu: [
        {
          id: rpmRTId,
          title: t('menu.lives'),
          path: rpmRT,
        },
        {
          id: dashboardEventId,
          title: t('menu.events'),
          path: dashboardEvent,
        },
        {
          id: dashboardRpmAlertId,
          title: t('menu.alerts'),
          path: dashboardRpmAlert,
        },
        {
          id: monitoringProtocolsId,
          title: t('menu.monitoringProtocol'),
          path: monitoringProtocols,
        },
        {
          id: patientsId,
          title: t('menu.patients'),
          path: `${patients}`,
        },
        {
          id: processId,
          title: t('menu.ecgAnalysisProcess'),
          path: process,
        },
      ],
    },
    {
      id: managementId,
      title: t('menu.management'),
      path: management,
      icon: <TeamOutlined />,
      subMenu: [
        {
          id: userListId,
          title: t('menu.users'),
          path: `${userManagement}`,
        },
        {
          id: sitesId,
          title: t('menu.sites'),
          path: `${sites}`,
        },
        {
          id: adminListId,
          title: t('menu.admins'),
          path: `${adminManagement}`,
        },
        {
          id: techListId,
          title: t('menu.technicians'),
          path: `${techManagement}`,
        },
        {
          id: physicianListId,
          title: t('menu.physicians'),
          path: `${physicianManagement}`,
        },
        {
          id: sensorsId,
          title: t('menu.sensors'),
          path: `${sensors}`,
        },
        {
          id: devicesId,
          title: t('menu.devices'),
          path: `${devices}`,
        },
        {
          id: tenantDeviceId,
          title: t('menu.deviceManagement'),
          path: `${tenantDevice}`,
        },
        {
          id: assessmentsManagementId,
          title: t('common.tenant'),
          path: clinics,
        },
      ],
    },
    {
      id: reportsId,
      title: t('menu.reports'),
      path: reports,
      icon: <FileTextOutlined />,
    },
    {
      id: reportArchiveId,
      title: t('menu.archive'),
      path: reportArchive,
      icon: <FileDoneOutlined />,
    },
    {
      id: historyId,
      title: t('menu.history'),
      path: historyView,
      icon: <HistoryOutlined />,
    },
    {
      id: 'downloads',
      title: t('menu.downloads'),
      path: `${downloads}`,
      icon: <DownloadOutlined />,
    },
    {
      id: settingsId,
      title: t('menu.settings'),
      path: `${settings}`,
      icon: <SettingOutlined />,
      subMenu: [
        {
          id: analysisSettingId,
          title: t('menu.analysisSetting'),
          path: analysisSetting,
        },
        {
          id: groupManagementId,
          title: t('menu.groupManagement'),
          path: groupManagement,
        },
        {
          id: otherSettingId,
          title: t('menu.otherSetting'),
          path: otherSetting,
        },
        {
          id: patientTemplateId,
          title: t('menu.patientTemplate'),
          path: patientTemplate,
        },
        {
          id: emailTemplateId,
          title: t('menu.emailTemplate'),
          path: emailTemplate,
        },
        {
          id: smsTemplateId,
          title: t('menu.smsTemplate'),
          path: smsTemplate,
        },
        {
          id: ssoSettingId,
          title: t('menu.sso'),
          path: ssoSetting,
        },
        // Absent rather than disabled when the clinic has MCP switched off. A
        // visible-but-dead entry advertises a feature the organization does not
        // have; direct navigation to the route still shows the not-available state.
        ...(user?.tenant?.mcpEnabled
          ? [
              {
                id: mcpSettingId,
                title: t('menu.mcpSetting'),
                path: mcpSetting,
              },
            ]
          : []),
      ],
    },
  ];

  const menuListTmp = useMemo(() => {
    if (user != null) {
      const rolesTmp = user.roles;
      const list: MenuItem[] = [];
      for (let i = 0; i < menuList.length; i += 1) {
        const item = menuList[i];
        // if (!rpmStatusTmp && rpmIds.includes(item.id)) {
        //   continue;
        // }
        // if (!isShowOrderManagement && item.id === orderManagementId) {
        //   continue;
        // }
        list.push(item);
      }
      return list;
    }
    return menuList;
  }, [menuList, user]);

  const hideMap = new Map([
    [addRpmPatient, rpmRT],
    [rpmRTList, rpmRT],
  ]);

  const findActive = useCallback((): [MenuItem | undefined, string[]] => {
    const pathname = history.location.pathname.split('/')?.[1];
    const pathAllname = history.location.pathname;
    for (let i = 0; i < menuListTmp.length; i += 1) {
      const item = menuListTmp[i];
      if (
        item.path?.includes(`/${pathname}`) ||
        item.path?.includes(management)
      ) {
        if (item.subMenu != null && item.subMenu.length > 0) {
          for (let j = 0; j < item.subMenu.length; j += 1) {
            const itemSub = item.subMenu[j];
            if (pathAllname.startsWith(itemSub.path)) {
              return [itemSub, [item.id]];
            }
          }
        }
      }
    }

    let menuItem = menuListTmp.find((el) => {
      const value = hideMap.get(pathAllname);
      if (value != null) {
        return el.path?.includes(value);
      }
      return el.path?.includes(pathAllname);
    });

    if (menuItem == null) {
      menuItem = menuListTmp.find((el) => {
        return el.path?.includes(pathname);
      });
    }

    return [menuItem, []];
  }, [history.location.pathname]);

  const findUser = useCallback(
    () =>
      user?.roles?.map((item: any) => {
        if (item.name === RolesEnum.ProgramManager) {
          return 'ProgramManager';
        }
        if (item.name === RolesEnum.SuperAdmin) {
          return 'SuperAdmin';
        }
        if (item.name === RolesEnum.SiteAdmin) {
          return 'Admin';
        }
        if (item.name === RolesEnum.TenantAdmin) {
          return 'TenantAdmin';
        }
        if (item.name === RolesEnum.VivaLNKAdmin) {
          return 'VivaLNKAdmin';
        }
        if (item.name === RolesEnum.EnrollmentCoordinator) {
          return 'EnrollmentCoordinator';
        }
        if (item.name === RolesEnum.ClinicalTrialCoordinator) {
          return 'ClinicalTrialCoordinator';
        }
        return item.name;
      }),
    [user],
  );

  const [active, setActive] = useState<MenuItem | undefined>(findActive()[0]);

  function setSubMenuTitle() {
    const menuSubmenuList = document.getElementsByClassName('ant-menu-submenu');
    if (menuSubmenuList != null && menuSubmenuList.length > 0) {
      for (let i = 0; i < menuSubmenuList.length; i += 1) {
        const element = menuSubmenuList[i];
        const menuTitleList = element.getElementsByClassName(
          'ant-menu-title-content',
        );
        if (menuTitleList != null && menuTitleList.length > 0) {
          const title = menuTitleList[0].innerHTML;
          element.setAttribute('title', title);
        }
      }
    }
  }

  useEffect(() => {
    setActive(findActive()[0]);
    findUser();
    setSubMenuTitle();
  }, [findActive, history, findUser, user]);

  useEffect(() => {
    const selectedOld = document.getElementsByClassName(
      'ant-menu-item-selected',
    );
    const subSelectedOld = document.getElementsByClassName(
      'ant-menu-submenu-selected',
    );
    if (
      (selectedOld != null && selectedOld.length > 0) ||
      (subSelectedOld != null && subSelectedOld.length > 0)
    ) {
      let ele = null;
      if (selectedOld != null && selectedOld.length > 0) {
        ele = selectedOld[0];
      }
      if (subSelectedOld != null && subSelectedOld.length > 0) {
        ele = subSelectedOld[0];
      }
      const svgs = ele?.getElementsByTagName('svg');
      if (svgs != null && svgs.length > 0) {
        const svg = svgs[0];
        if (
          settingInfo != null &&
          settingInfo?.theme != null &&
          settingInfo.theme?.staticTextColor != null
        ) {
          svg.style.fill = settingInfo.theme?.staticTextColor;
        }
      }
    }
    setTimeout(() => {
      const selected = document.getElementsByClassName(
        'ant-menu-item-selected',
      );
      const subSelected = document.getElementsByClassName(
        'ant-menu-submenu-selected',
      );
      if (
        (selected != null && selected.length > 0) ||
        (subSelected != null && subSelected.length > 0)
      ) {
        let ele = null;
        if (selected != null && selected.length > 0) {
          ele = selected[0];
        }
        if (subSelected != null && subSelected.length > 0) {
          ele = subSelected[0];
        }
        const svgs = ele?.getElementsByTagName('svg');
        if (svgs != null && svgs.length > 0) {
          const svg = svgs[0];
          if (
            settingInfo != null &&
            settingInfo?.theme != null &&
            settingInfo.theme?.activatedTextColor != null
          ) {
            svg.style.fill = settingInfo.theme?.activatedTextColor;
          }
        }
      }
    }, 10);
  }, [
    document.getElementsByClassName('ant-menu-item-selected'),
    findActive,
    settingInfo,
  ]);

  const activeId =
    history.location.pathname.slice(0, 14) === '/studies-sites'
      ? studiesId
      : active?.id;

  const [subMenuKeys, setSubMenuKeys] = useState<string[]>(findActive()[1]);
  let subMenuFirstOpenStatus = true;

  useEffect(() => {
    const keys_ = findActive()[1];
    setSubMenuKeys(keys_);
  }, []);

  const onOpenChange = useCallback((penKeys: string[]) => {
    if (!subMenuFirstOpenStatus) {
      setSubMenuKeys(penKeys);
    }
    subMenuFirstOpenStatus = false;
  }, []);

  return (
    <MenuAnt
      selectedKeys={[activeId || menuListTmp[0].id]}
      openKeys={subMenuKeys}
      theme="light"
      mode="inline"
      onOpenChange={onOpenChange}
      className="yahuikeji-layout-menu"
      items={MenuItems({
        menuList: menuListTmp,
        roleNames: findUser(),
      })}
      style={
        settingInfo?.theme?.backgroundColor == null
          ? {}
          : { backgroundColor: settingInfo.theme.backgroundColor }
      }
    />
  );
}
